import React from "react";
import { useWalkthrough } from "../../services/WalkthroughContext";

function IntroA({ info = "" }) {
  const { listening, explainer, toggleListening, toggleExplainer, goTo, steps } = useWalkthrough();
  return (
    <div
      style={{
        position: "relative",
        width: "100vw",
        height: "100vh",
        boxSizing: "border-box",
        padding: "24px 8px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "space-between",
      }}
    >
      {/* Dismiss walkthrough: set index beyond last so currentStep becomes null */}
      {/* <div style={{ position: "absolute", left: 12, top: 12, zIndex: 30, display: "flex", alignItems: "center", gap: 8 }}>
        <button
          onClick={(e) => {
            e.stopPropagation();
            // move index past last step to hide the walkthrough UI
            try {
              const len = (steps || []).length;
              goTo(len);
            } catch (err) {
              // ignore
            }
          }}
          style={{
            background: "rgba(0,0,0,0.5)",
            color: "#fff",
            border: "none",
            borderRadius: 6,
            padding: "6px 10px",
            cursor: "pointer",
          }}
          aria-label="Close walkthrough"
        >
          ✕
        </button>
        <div style={{ display: "flex", gap: 4 }}>
          {(steps || []).map((step, idx) => (
            <button
              key={step.id || idx}
              onClick={(e) => {
                e.stopPropagation();
                goTo(idx);
              }}
              style={{
                background: "#eee",
                color: "#222",
                border: "1px solid #bbb",
                borderRadius: 4,
                padding: "2px 8px",
                fontSize: 12,
                cursor: "pointer",
                fontWeight: 500,
              }}
              title={step.id || `Step ${idx+1}`}
            >
              {idx+1}
            </button>
          ))}
        </div>
      </div> */}
      {/* Version info at top center */}
      <div
        style={{
          width: "100%",
          textAlign: "center",
          fontSize: 14,
          marginTop: 16,
          marginBottom: 32,
          color: "#fff",
        }}
      >
        {info}
      </div>
      {/* Logos area */}
      <div style={{ width: "80%", maxWidth: "900px" }}>
        <img
          src={"/assets/walkthrough/ECHO_and_ESA.svg"}
          alt="ECHO and ESA Logos"
          style={{
            width: "100%",
            height: "auto",
            display: "block",
          }}
        />
      </div>
      {/* Mode cards row */}
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          gap: 25,
          maxWidth: "100%",
          width: "100%",
          flexWrap: "wrap",
          justifyContent: "center",
        }}
      >
        {/* Listening Mode Card */}
        <div
          style={{
            background: "#fff",
            borderRadius: 8,
            boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
            padding: "24px 20px",
            display: "flex",
            alignItems: "center",
            minWidth: 140,
            maxWidth: 250,
            width: "100%",
            cursor: "pointer",
          }}
          onClick={toggleListening}
        >
          {/* Toggle ON/OFF */}
          <div
            style={{
              width: 40,
              height: 24,
              borderRadius: 12,
              background: listening ? "#097d46" : "#ccc",
              display: "flex",
              alignItems: "center",
              padding: 2,
              marginRight: 20,
              transition: "background 0.2s",
            }}
          >
            <div
              style={{
                width: 20,
                height: 20,
                borderRadius: "50%",
                background: "#fff",
                boxShadow: "0 1px 4px rgba(0,0,0,0.10)",
                marginLeft: listening ? 16 : 2,
                transition: "margin 0.2s",
              }}
            />
          </div>
          {/* Texts */}
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
            }}
          >
            <span
              style={{
                fontSize: 15,
                textTransform: "uppercase",
                color: "#222",
                letterSpacing: 1,
                marginBottom: 2,
              }}
            >
              Listening Mode
            </span>
            <span style={{ fontSize: 13, color: listening ? "#097d46" : "#888" }}>{listening ? "ON" : "OFF"}</span>
          </div>
        </div>
        {/* Explanation Mode Card */}
        <div
          style={{
            background: "#fff",
            borderRadius: 8,
            boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
            padding: "24px 20px",
            display: "flex",
            alignItems: "center",
            minWidth: 140,
            maxWidth: 250,
            width: "100%",
            cursor: "pointer",
          }}
          onClick={toggleExplainer}
        >
          {/* Toggle ON/OFF */}
          <div
            style={{
              width: 40,
              height: 24,
              borderRadius: 12,
              background: explainer ? "#097d46" : "#ccc",
              display: "flex",
              alignItems: "center",
              padding: 2,
              marginRight: 20,
              transition: "background 0.2s",
            }}
          >
            <div
              style={{
                width: 20,
                height: 20,
                borderRadius: "50%",
                background: "#fff",
                boxShadow: "0 1px 4px rgba(0,0,0,0.10)",
                marginLeft: explainer ? 16 : 2,
                transition: "margin 0.2s",
              }}
            />
          </div>
          {/* Texts */}
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
            }}
          >
            <span
              style={{
                fontSize: 15,
                textTransform: "uppercase",
                color: "#222",
                letterSpacing: 1,
                marginBottom: 2,
              }}
            >
              Explanation Mode
            </span>
            <span style={{ fontSize: 13, color: explainer ? "#097d46" : "#888" }}>{explainer ? "ON" : "OFF"}</span>
          </div>
        </div>
      </div>
      {/* Spacer at bottom */}
      <div style={{ height: 40 }} />
    </div>
  );
}

export default IntroA;
